const API_URL_BY_ENV = {
    local: 'http://localhost:3301/api',
    dev: 'https://payup-api-dev.iilm.io/api',
    staging: 'https://staging-api.payup.com/api',
    production: 'https://api.payup.com/api',
};
export class Config {
    constructor() {
        this.config = this.loadConfig();
    }
    static getInstance() {
        if (!Config.instance) {
            Config.instance = new Config();
        }
        return Config.instance;
    }
    loadConfig() {
        const script = this.getScriptElement();
        const apiUrl = script?.getAttribute('data-api-url') ||
            this.getDefaultApiUrl();
        const messageOrigin = script?.getAttribute('data-message-origin') ||
            apiUrl.replace('/api', '');
        return {
            VERSION: '3.0.0',
            API_BASE_URL: apiUrl,
            MESSAGE_ORIGIN: messageOrigin,
        };
    }
    getScriptElement() {
        return document.currentScript ||
            document.querySelector('script[data-client-token]');
    }
    getDefaultApiUrl() {
        const env = this.getScriptElement()?.getAttribute('data-env') ||
            (typeof __PAYUP_SDK_DEFAULT_ENV__ !== 'undefined' ? __PAYUP_SDK_DEFAULT_ENV__ : 'local');
        const resolvedEnv = env === 'development' ? 'local' : env;
        return API_URL_BY_ENV[resolvedEnv] ?? API_URL_BY_ENV.local;
    }
    get() {
        return { ...this.config };
    }
    getVersion() {
        return this.config.VERSION;
    }
    getApiBaseUrl() {
        return this.config.API_BASE_URL;
    }
    getMessageOrigin() {
        return this.config.MESSAGE_ORIGIN;
    }
    updateConfig(updates) {
        this.config = { ...this.config, ...updates };
    }
}
export const getConfig = () => Config.getInstance().get();
